import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { RespiAllerReferralData } from '@common/validation/customControls/allergology/respiAllerReferral/v1/respiAllerReferralSchemaV1';
import { CustomControlMode, ProcessActivityStatus, ServiceCode } from '@common/enums';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { PatientInsurance } from '../../patientInsurance/PatientInsurance';
import { ProcessActivityAnamnesisRead } from '../../processActivityAnamnesis/ProcessActivityAnamnesisRead';
import { ProcessActivityMedicationsRead } from '../../processActivityMedications/ProcessActivityMedicationsRead';
import { ProcessActivityProfessionalSummaryDataRead } from '../../processActivityProfessionalSummaryData/ProcessActivityProfessionalSummaryDataRead';
import { RespiAllerFollowingSteps } from './RespiAllerFollowingSteps';

export function RespiAllerReferralRead() {
    const translate = getSelectedLanguage();
    const { processActivity } = useProcessActivityReadContext<RespiAllerReferralData>();
    const { customControlData } = processActivity;

    return (
        <>
            <PatientInsurance
                mode={CustomControlMode.read}
                serviceCode={ServiceCode.RespiAller}
            />
            <FormSection title={translate.common.referral}>
                <FormGroup
                    label={
                        processActivity.status === ProcessActivityStatus.complete
                            ? translate.common.sentTo
                            : translate.common.willSendTo
                    }
                >
                    <FormParagraph>{translate.companies.ksyosAllergology}</FormParagraph>
                </FormGroup>
            </FormSection>

            <ProcessActivityAnamnesisRead data={customControlData} />

            <ProcessActivityMedicationsRead
                patientUsesMedication={customControlData.patientUsesMedication}
                processActivityId={processActivity.id}
            />

            <ProcessActivityProfessionalSummaryDataRead processActivityId={processActivity.id} />

            <FormSection title={translate.common.referralQuestion}>
                <FormParagraphFormGroup label={translate.allergology.allergistReferralQuestion}>
                    {customControlData.referralQuestion}
                </FormParagraphFormGroup>
            </FormSection>

            <FormSection title={translate.common.contactPatient}>
                <FormParagraphFormGroup label={translate.common.email}>
                    {customControlData.patient.emailAddress}
                </FormParagraphFormGroup>
                {customControlData.patient.mobileNumber && (
                    <FormParagraphFormGroup label={translate.common.mobileTelephoneNumber}>
                        {customControlData.patient.mobileNumber}
                    </FormParagraphFormGroup>
                )}
                {customControlData.patient.homePhoneNumber && (
                    <FormParagraphFormGroup label={translate.common.homeNumber}>
                        {customControlData.patient.homePhoneNumber}
                    </FormParagraphFormGroup>
                )}
            </FormSection>

            <RespiAllerFollowingSteps />
        </>
    );
}
